// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E7jE","colBig":"styles_colBig__2ezOB","colSmall":"styles_colSmall__3ENNW"};